<div class="bg-white border m-2 pt-3 px-3 d-flex flex-column shadow-sm">
  <div class="border-bottom pb-1">
    <strong class="text-primary">Sync status</strong>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Wifi Profiles</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.wifiProfiles"> </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.WifiProfiles"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Notification Profiles</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.notificationProfiles">
      </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.NotificationProfiles"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Applications</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.applications"> </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.Applications"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Application Configurations</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.applicationConfigurations">
      </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry
                                    [currentSyncType]="SyncType.EraApplicationConfiguration"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>App Lock Profile</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.appLockProfile"> </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.AppLockProfile"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Restrictions Profiles</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.restrictionsProfiles">
      </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.RestrictionsProfiles"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>AirPlay Security Profile</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.airPlaySecurityProfile">
      </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.AirplaySecurityProfile"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Device Name</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.deviceName"> </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.DeviceName"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="row">
    <div class="col small pt-2">
      <strong>Configuration Profiles</strong>
    </div>
    <div class="col-auto align-content-center">
      <era-device-sync-status-indicator [status]="deviceStatus.configurationProfiles">
      </era-device-sync-status-indicator>
    </div>
    <div class="col-auto p-0">
      <era-device-sync-status-retry [currentSyncType]="SyncType.ConfigurationProfiles"></era-device-sync-status-retry>
    </div>
  </div>
  
  <div class="pb-2"></div>
  
  <era-device-mdm-sync-retry></era-device-mdm-sync-retry>
</div>